import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { toCommaNumber } from 'common/formatters';
import { ActionList, IconList, Input } from 'common/components';
import { required } from 'common/form-validators';
import { capitalizeString } from 'common/utils';

class FertilizersChemicalsField extends Component {
  getActionBoxTitle = str => {
    const obj = JSON.parse(str);
    return (
      <strong>
        {obj.name}{' '}
        {obj.max ? (
          <span className={'text--label'}>(Max. {toCommaNumber(obj.max)})</span>
        ) : (
          ''
        )}
      </strong>
    );
  };

  getFieldSettings = (obj = {}) => ({
    fertilizer: {
      component: (
        <IconList
          list={[
            {
              label: `N ${obj.nitrogen} : P ${obj.phosphorus} : K ${
                obj.potassium
              } : S ${obj.sulfur} : Z ${obj.zinc}`,
              icon: 'fertilizer',
            },
          ]}
        />
      ),
      inputTitle: 'Fertilization Rate',
      hintText: 'in lb/acre or kg/acre or l/acre',
    },
    chemical: {
      component: (
        <Fragment>
          {obj.brand && (
            <p className="cardlist__chemicals cardlist__chemicals--brand">
              {obj.brand}
            </p>
          )}
          <p className="cardlist__chemicals">{capitalizeString(obj.type)}</p>
        </Fragment>
      ),
      inputTitle: 'Chemical Mix Rate',
    },
  });

  getContent = (option, item, i) => {
    if (!item) {
      return;
    }

    const { submitting, mode } = this.props;
    const {
      result: { key },
    } = option;
    const obj = JSON.parse(item);

    const { component, inputTitle, hintText } = this.getFieldSettings(obj)[
      mode
    ];

    return (
      <Fragment key={`${key}_amount${i}`}>
        {this.getActionBoxTitle(item)}
        {component}
        <Input
          title={inputTitle}
          hintText={hintText}
          name={`${key}_amount[${i}]`}
          disabled={submitting}
          validate={[required]}
          theme={['tight']}
          validateOnChange
        />
      </Fragment>
    );
  };

  render() {
    const { option, arrayRemove, toggleModal, mode } = this.props;
    const {
      result: { value = [], key },
    } = option;
    if (value.length === 0) {
      return null;
    }

    return (
      <ActionList
        cards={value.map((item, i) => ({
          content: this.getContent(option, item, i),
          actions: [
            {
              icon: 'edit',
              action: () => toggleModal(item, `${key}[${i}]`, mode),
            },
            {
              icon: 'garbage',
              action: () => {
                arrayRemove(key, i);
                arrayRemove(`${key}_amount`, i);
              },
            },
          ],
        }))}
      />
    );
  }
}

FertilizersChemicalsField.propTypes = {
  submitting: PropTypes.bool,
  option: PropTypes.object,
  arrayRemove: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['fertilizer', 'chemical']).isRequired,
};

export default FertilizersChemicalsField;



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/fields/FertilizersChemicalsField.js